<div *ngIf="options">
  <div class="relative">
    <button
      type="button"
      class="w-full py-1.5 text-primary-500 focus:outline-none text-base font-medium"
      (click)="toggleDropdown()"
    >
      <span class="flex items-center justify-end">
        <svg
          class="hidden lg:block"
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
        >
          <path
            d="M12.5 5.625C11.6842 5.625 10.8866 5.86693 10.2083 6.32019C9.52992 6.77345 9.00121 7.41769 8.689 8.17143C8.37679 8.92518 8.2951 9.75458 8.45426 10.5547C8.61343 11.3549 9.00629 12.0899 9.58318 12.6668C10.1601 13.2437 10.8951 13.6366 11.6953 13.7957C12.4954 13.9549 13.3248 13.8732 14.0786 13.561C14.8323 13.2488 15.4766 12.7201 15.9298 12.0417C16.3831 11.3634 16.625 10.5658 16.625 9.75C16.6238 8.65636 16.1888 7.60787 15.4154 6.83455C14.6421 6.06124 13.5936 5.62624 12.5 5.625ZM12.5 11.625C12.1292 11.625 11.7666 11.515 11.4583 11.309C11.15 11.103 10.9096 10.8101 10.7677 10.4675C10.6258 10.1249 10.5887 9.74792 10.661 9.3842C10.7334 9.02049 10.912 8.6864 11.1742 8.42417C11.4364 8.16195 11.7705 7.98337 12.1342 7.91103C12.4979 7.83868 12.8749 7.87581 13.2175 8.01772C13.5601 8.15964 13.853 8.39996 14.059 8.70831C14.265 9.01665 14.375 9.37916 14.375 9.75C14.375 10.2473 14.1775 10.7242 13.8258 11.0758C13.4742 11.4275 12.9973 11.625 12.5 11.625ZM12.5 1.125C10.2133 1.12748 8.02091 2.03698 6.40394 3.65394C4.78698 5.27091 3.87748 7.46327 3.875 9.75C3.875 17.0025 11.5288 22.4437 11.855 22.6716C12.0441 22.8039 12.2692 22.8748 12.5 22.8748C12.7308 22.8748 12.9559 22.8039 13.145 22.6716C14.5946 21.6032 15.9209 20.3769 17.0994 19.0153C19.7328 15.9909 21.125 12.7847 21.125 9.75C21.1225 7.46327 20.213 5.27091 18.5961 3.65394C16.9791 2.03698 14.7867 1.12748 12.5 1.125ZM15.4344 17.5041C14.5405 18.5308 13.5586 19.4776 12.5 20.3334C11.4414 19.4776 10.4595 18.5308 9.56562 17.5041C8 15.6909 6.125 12.8728 6.125 9.75C6.125 8.05924 6.79665 6.43774 7.99219 5.24219C9.18774 4.04665 10.8092 3.375 12.5 3.375C14.1908 3.375 15.8123 4.04665 17.0078 5.24219C18.2034 6.43774 18.875 8.05924 18.875 9.75C18.875 12.8728 17 15.6909 15.4344 17.5041Z"
            fill="#3D5CF5"
          />
        </svg>
        <span class="mr-2 lg:mr-4 ml-2">{{
          selectedOption ? selectedOption[description] : label
        }}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
        >
          <path
            d="M7.982 11.831L2.04814 5.89714C1.76195 5.61096 1.76195 5.14698 2.04814 4.86082L2.74023 4.16873C3.02592 3.88304 3.48896 3.88249 3.77532 4.16751L8.50018 8.87023L13.225 4.16751C13.5114 3.88249 13.9744 3.88304 14.2601 4.16873L14.9522 4.86082C15.2384 5.14701 15.2384 5.61099 14.9522 5.89714L9.01835 11.831C8.73217 12.1172 8.26819 12.1172 7.982 11.831Z"
            fill="#3D5CF5"
          />
        </svg>
      </span>
    </button>
    <div class="absolute z-50 mt-1 right-1/2 translate-x-1/2 lg:translate-x-0 lg:right-0 rounded-md bg-white overflow-hidden ring-1 ring-black shadow-lg ring-opacity-5 focus:outline-none">
      <ul
      class="max-h-56 min-w-fit overflow-auto py-1 text-base"
        tabindex="-1"
        role="listbox"
        [ngClass]="{ hidden: !isDropdownOpen }"
      >
        <li
          class="text-gray-900 hover:text-white hover:bg-primary-500 cursor-pointer py-2 pl-3 pr-9 font-normal whitespace-nowrap"
          *ngFor="let option of options"
          (click)="chooseOption(option[value])"
        >
          {{ option[description] }}
        </li>
      </ul>
    </div>
  </div>
</div>
